import React, { useState } from 'react';

const QUICK_TAGS = ['OpenAI', 'Stripe', 'Figma', 'Anthropic', 'SpaceX', 'Notion'];

const styles = {
  hero: { textAlign: 'center', marginBottom: '60px' },
  heroTag: {
    display: 'inline-block', fontFamily: 'var(--font-mono)', fontSize: '12px',
    color: 'var(--neon)', letterSpacing: '0.25em', border: '1px solid var(--border2)',
    padding: '7px 22px', marginBottom: '28px', borderRadius: '3px',
  },
  h1: {
    fontFamily: 'var(--font-head)', fontSize: 'clamp(32px, 5vw, 60px)',
    fontWeight: 900, letterSpacing: '0.04em', lineHeight: 1.1,
    color: '#fff', marginBottom: '20px',
  },
  span: { color: 'var(--neon)' },
  p: { fontSize: '17px', color: 'var(--text2)', maxWidth: '540px', margin: '0 auto 40px', lineHeight: 1.8 },
  searchWrap: { maxWidth: '680px', margin: '0 auto' },
  searchBox: {
    display: 'flex', alignItems: 'center',
    background: 'var(--bg2)', border: '1px solid var(--border2)',
    borderRadius: '6px', overflow: 'hidden', transition: 'border-color 0.3s, box-shadow 0.3s',
  },
  searchBoxFocused: { borderColor: 'var(--neon)', boxShadow: '0 0 0 1px var(--neon), 0 0 40px rgba(0,255,231,0.12)' },
  prefix: {
    fontFamily: 'var(--font-mono)', fontSize: '14px', color: 'var(--neon)',
    padding: '0 18px', borderRight: '1px solid var(--border)', whiteSpace: 'nowrap',
  },
  input: {
    flex: 1, background: 'transparent', border: 'none', outline: 'none',
    color: '#fff', fontFamily: 'var(--font-mono)', fontSize: '16px',
    padding: '18px 18px', letterSpacing: '0.05em',
  },
  btn: {
    background: 'var(--neon)', color: 'var(--bg)', border: 'none', cursor: 'pointer',
    fontFamily: 'var(--font-head)', fontSize: '12px', fontWeight: 700,
    letterSpacing: '0.15em', padding: '0 28px', height: '58px',
    whiteSpace: 'nowrap', transition: 'background 0.2s',
  },
  btnDisabled: { opacity: 0.4, cursor: 'not-allowed' },
  quickTags: { display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '18px' },
  quickTag: {
    fontFamily: 'var(--font-mono)', fontSize: '12px', color: 'var(--text2)',
    border: '1px solid var(--border)', padding: '6px 14px', borderRadius: '3px',
    cursor: 'pointer', background: 'transparent', transition: 'all 0.2s',
  },
};

export default function SearchBar({ onSearch, loading }) {
  const [value, setValue] = useState('');
  const [focused, setFocused] = useState(false);

  const handleSubmit = () => { if (value.trim() && !loading) onSearch(value.trim()); };
  const handleKeyDown = (e) => { if (e.key === 'Enter') handleSubmit(); };

  return (
    <div style={styles.hero}>
      <div className="fade-up" style={styles.heroTag}>// DEEP RESEARCH AGENT v2.4</div>
      <h1 className="fade-up-1" style={styles.h1}>
        Instant <span style={styles.span}>intelligence</span><br />on any company
      </h1>
      <p className="fade-up-2" style={styles.p}>
        Enter a company name. The agent autonomously searches the web across multiple research loops and delivers an investor-grade report in seconds.
      </p>
      <div className="fade-up-3" style={styles.searchWrap}>
        <div style={{ ...styles.searchBox, ...(focused ? styles.searchBoxFocused : {}) }}>
          <div style={styles.prefix}>TARGET://</div>
          <input
            style={styles.input} type="text"
            placeholder="e.g. Stripe, OpenAI, Tesla, Notion..."
            value={value} onChange={e => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
            onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
            autoComplete="off"
          />
          <button
            style={{ ...styles.btn, ...(loading ? styles.btnDisabled : {}) }}
            onClick={handleSubmit} disabled={loading}
            onMouseEnter={e => { if (!loading) e.target.style.background = '#fff'; }}
            onMouseLeave={e => { e.target.style.background = 'var(--neon)'; }}
          >
            {loading ? 'ANALYZING...' : 'ANALYZE'}
          </button>
        </div>
        <div style={styles.quickTags}>
          {QUICK_TAGS.map(tag => (
            <button key={tag} style={styles.quickTag} onClick={() => setValue(tag)}
              onMouseEnter={e => { e.target.style.color = 'var(--neon)'; e.target.style.borderColor = 'var(--neon)'; }}
              onMouseLeave={e => { e.target.style.color = 'var(--text2)'; e.target.style.borderColor = 'var(--border)'; }}
            >{tag}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
